import React from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import EmptyState from '../components/EmptyState';

function NotFound() {
  return (
    <EmptyState
      icon={Compass}
      title="Page not found"
      description="The page you're looking for doesn't exist or you don't have access."
      action={<Link to="/dashboard" className="btn btn-primary">Back to dashboard</Link>}
    />
  );
}

export default NotFound;
